module.exports = __webpack_public_path__ + "assets/images/animations/kfc-animation.webp?092004a0";